import { FieldType } from '@/components/table/_fieldDefinitions/FieldType.ts';
import React, { ReactNode } from 'react';
import { SquareCheckBig, Type, AlignLeft, CheckSquare } from 'lucide-react';

export interface CustomFieldTypeConfig {
  type: FieldType;
  title: string;
  description: string;
  icon: ReactNode;
}

export const customFieldTypeConfigs = new Map<FieldType, CustomFieldTypeConfig>(
  [
    [
      FieldType.TEXT,
      {
        type: FieldType.TEXT,
        title: 'Tekst',
        description: 'krótka informacja, np. nazwa szkoły, klasa',
        icon: <Type />,
      },
    ],
    [
      FieldType.LONG_TEXT,
      {
        type: FieldType.LONG_TEXT,
        title: 'Tekst długi',
        description: 'dłuższa informacja, np. opis, komentarz',
        icon: <AlignLeft />,
      },
    ],
    [
      FieldType.CHECKBOX,
      {
        type: FieldType.CHECKBOX,
        title: 'Checkbox',
        description: 'pole zaznaczenia, np. zgoda na regulamin',
        icon: <CheckSquare />,
      },
    ],
    [
      FieldType.DROPDOWN,
      {
        type: FieldType.DROPDOWN,
        title: 'Wybór opcji jednokrotny',
        description: 'wybór jednej z wielu opcji, np. rozmiar koszulki',
        icon: <SquareCheckBig />,
      },
    ],
  ],
);

export const getFieldTypeConfig = (type: FieldType): CustomFieldTypeConfig => {
  switch (type) {
    case FieldType.TEXT:
      return customFieldTypeConfigs.get(FieldType.TEXT)!;
    case FieldType.LONG_TEXT:
      return customFieldTypeConfigs.get(FieldType.LONG_TEXT)!;
    case FieldType.CHECKBOX:
      return customFieldTypeConfigs.get(FieldType.CHECKBOX)!;
    case FieldType.DROPDOWN:
      return customFieldTypeConfigs.get(FieldType.DROPDOWN)!;
    default:
      throw new Error(`Unsupported field type: ${type}`);
  }
};
